module.exports = __webpack_public_path__ + "static/media/navel.c935d9f2.png";